import axios from "axios"

const fetchGetAllTicketsRequest = () => {
	return {type: "FETCH_GET_ALL_TICKETS_REQUEST"}
}

const fetchGetAllTicketsSuccess = (get_all_tickets) => {
	return {type: "FETCH_GET_ALL_TICKETS_SUCCESS", payload: get_all_tickets}
}

const fetchGetAllTicketsFailure = (error) => {
	return {type: "FETCH_GET_ALL_TICKETS_FAILURE", payload: error}
}

export const fetchGetAllTickets = (ticket) => {
	return (dispatch) => {
		dispatch(fetchGetAllTicketsRequest())
		axios.get("admin/tickets", ticket)
		.then(response => {
			const get_all_tickets = response.data
			dispatch(fetchGetAllTicketsSuccess(get_all_tickets))	
		})
		.catch(err => {
			const error = err.message
			dispatch(fetchGetAllTicketsFailure(error))	
		})
	}
}

export const fetchAllTicketsPagination = (e) => {
	return (dispatch) => {
		dispatch(fetchGetAllTicketsRequest())
		axios.get(e)
		.then(response => {
			const get_all_tickets = response.data
			dispatch(fetchGetAllTicketsSuccess(get_all_tickets))	
		})
		.catch(err => {
			const error = err.message
			dispatch(fetchGetAllTicketsFailure(error))	
		})
	}
}